import find from 'lodash/find';
import { computed } from 'vue';

import PetSpecies from '@/enums/PetSpecies';
import SubscriptionPlanCoverageType from '@/enums/SubscriptionPlanCoverageType';

export default function useSubscriptionHelpers(root) {
  const rootGetters = root.$store.getters;

  const subscriptionPlan = computed(() => rootGetters['subscriptions/getMembershipSubscription'] || rootGetters['subscriptionPlans/getYearlySubscriptionPlan']);

  const subscriptionFleaAndTickDiscount = computed(() => {
    const benefit = find(subscriptionPlan.value?.benefits, { coverage_type: SubscriptionPlanCoverageType.FleaAndTick });

    return parseFloat(benefit?.coinsurance_percent ?? 0) * 100;
  });

  const ruffyFleaAndTickDiscount = computed(() => (root.$statsig.ready && root.$statsig.getDynamicConfig('ecomm_flea_tick_max_discount')?.value?.CA) || 30);

  const fleaAndTickDiscount = computed(() => {
    if (rootGetters.isEcommerceCapable) {
      return subscriptionFleaAndTickDiscount.value;
    }

    // Only ON Canada gets 30% discount on F&T via Ruffy - dynamic config has ON region check.
    return ruffyFleaAndTickDiscount.value;
  });

  // Enabled for CA ON and US VCPR regions
  const isFleaAndTickDiscountEnabled = computed(() => root.$statsig.ready && root.$statsig.checkGate('ecomm_flea_tick_product_discount'));

  const hasFleaAndTickDiscount = computed(() => isFleaAndTickDiscountEnabled.value && fleaAndTickDiscount.value > 0);

  const isSpeciesEligibleForAllergies = (species) => [PetSpecies.Dog].includes(species);
  const isSpeciesEligibleForFleaAndTick = (species) => [PetSpecies.Dog, PetSpecies.Cat].includes(species);

  return {
    fleaAndTickDiscount,
    hasFleaAndTickDiscount,
    isSpeciesEligibleForAllergies,
    isSpeciesEligibleForFleaAndTick,
  };
}
